import matchers from "@testing-library/jest-dom/matchers";
import RegisterEquipment from "Components/Core/Equipment/RegisterEquipment";

export const PLATFORM_CODE = 'V3CONDEL';

export const ls_vars = {
  ACCESS_TOKEN: "v3_access_token",
  REFRESH_TOKEN: "v3_refresh_token",
  LANGUAGE: "i18nextLng",
  REGION_ID: "v3_region_id",
  PROJECT_REF: "v3_project_ref",
  PROJECT_DATA: "v3_project_data",
  PROJECT_TIMEZONE: "v3_project_timezone",
  PROJECT_SETTINGS: "v3_project_settings",
  PROJECT_BOOKING_FIELDS: "v3_project_booking_fields",
  PROJECT_PROCORE_INTEGRATION_ID: "v3_project_procore_int_id",
  PROJECT_SITE_ID: "v3_project_site_id",
  PROJECT_ROLE: "v3_project_role",
  USER_DATA: "v3_user_data",
  USER_PROJECTS: "v3_user_projects",
  USER_PREFERENCES: "v3_user_preference",
  USER_IS_ADMIN: "v3_user_is_admin",
  USER_INVITE_DATA: "v3_user_invite_data",
  BOOKING_FLEX_FORMS: "v3_booking_flex_forms",
  COUNTRY_CODE: "v3_country_code",
  COUNTRY_UOM: "v3_country_uom",
  PUSH_NOTIFICATION_PREFERENCE: "v3_push_notification_preference",
  BOOKING_EDIT_MODE: "v3_booking_edit_mode",
};

export const baseUserRoles = {
  OWNER: { id: 1, code: "project:owner", name: "Project Owner" },
  ADMIN: { id: 2, code: "project:admin", name: "Project Admin" },
  MANAGER: { id: 3, code: "project:manager", name: "Project Manager" },
  USER: { id: 4, code: "project:user", name: "Project User" },
};

export const constants = {
  PROJECT_OWNER: "Project Owner",
  PROJECT_USER: "Project User",
  PROJECT_USER_SENIOR: "Project Senior User",
  PROJECT_MANAGER: "Project Manager",
  PROJECT_ADMIN: "Project Admin",
  PROJECT_GUARD: "Security Guard",
  PROJECT_VIEW_ONLY: "View Only",
  MONTHLY: "MONTHLY",
  WEEKLY: "WEEKLY",
  HOUR_24: "24 hour",
  HOUR_12: "12 hour",
  BOOKING_TYPES: "bookingTypes",
  ACCESS_POINTS: "accessPoints",
  VEHICLE_TYPES: "vehicleTypes",
  RESOURCES: "resources",
  RECIPIENT_COMPANIES: "recipientCompanies",
  CREATOR_COMPANIES: "creatorCompanies",
  STATUS: "statuses",
  GOOGLE_MAP_MARKER:
    "https://icon-library.com/images/pin-icon-png/pin-icon-png-23.jpg",
  SUPPORT_EMAIL: "support@voyagecontrol.com",
  REGION: "Region",
  INCOMPLETE_ONBOARDING: "incomplete_onboarding",
  VIEW_PROJECT_SETTINGS: "VIEW_PROJECT_SETTINGS",
  VIEW_INTEGRATIONS: "VIEW_INTEGRATIONS",
  VIEW_VEHICLE_TRACKING: "VIEW_VEHICLE_TRACKING",
  PROCORE_DAILY_LOG: "PROCORE_DAILY_LOG",
  PROCORE: "PROCORE",
  INTEGRATION_PROCORE: "INTEGRATION_PROCORE",
  PRO_FEATURE_PROCORE_DAILY_LOG: "PRO_FEATURE_PROCORE_DAILY_LOG",
  FLAG_PROJECT_SETTINGS: "FLAG_PROJECT_SETTINGS",
  ORGANIZATION_ADMIN: "admin",
  ORGANIZATION_USER: "user",
  ENVIRONMENT_ADMIN: "Environment Admin",
  SUPPLIER_EQUIPMENT_COORDINATOR: "Supplier Equipment Coordinator",
  EQUIPMENT_ANALYTICS_ADMIN: "Equipment Analytics Admin"
};

export const userStatuses: any = {
  "-2": "Blocked",
  "-1": "Restricted",
  "0": "Invited",
  "2": "Expired",
  "1": "Active",
};

export const bookingTypes = {
  DELIVERY: "delivery",
  MULTI_VEHICLE: "multi-vehicle",
  RECURRING: "recurring",
  RESOURCE_ONLY: "resource-only",
};

export const routes = {
  auth: {
    login: "/login",
    redirect: "/redirect",
    choseProject: "/project/choose",
    procoreWebhookUrl: "/authenticate/procore/callback",
  },
  profile: {
    account: "/myaccount",
    organization: "/organization",
    notification: "/notification/preference",
  },
  notifications: {
    center: "/notifications/center",
  },
  dashboard: {
    home: "/:project/home",
    userManagement: "/:project/dashboard/manage-user",
    siteDetails: "/:project/site-details",
    settings: "/:project/settings",
    settingsProcore: "/:project/settings/integrations/procore",
    availability: "/:project/availability",
    bookingForm: "/:project/booking-form/:bookingId",
    bookingDetails: "/:project/booking/:bookingId",
    bookingsList: "/:project/booking",
    vehicleTracking: "/:project/vehicle-tracking",
    calendar: "/:project/calendar",
    equipment: "/:project/equipment",
    listEquipments: "/:project/list-equipment",
    registerEquipment: "/:project/register-equipment",
    monthlyUsage: "/:project/monthly-usage",
    vehicleMaster: "/:project/vehicle-master",
    vehicleEmission: "/:project/vehicle-emission",
    country: "/:project/country",
    materialEmissionReport: "/:project/material-emission-report",
    offRoadEmissionsReport: "/:project/off-road-emissions-report",
    summaryEmissionsReport: "/:project/summary-emissions-report",
    environmentReport: "/:project/environment-report",
    commonSettings: "/:project/settings/common-settings",
  },
  userDeleteGuidance: "/user-delete-guidance",
  dashboardNav: {
    home: (projectRef: string) => `/${projectRef}/home`,
    userManagement: (projectRef: string) =>
      `/${projectRef}/dashboard/manage-user`,
    siteDetails: (projectRef: string) => `/${projectRef}/site-details`,
    settings: (projectRef: string) => `/${projectRef}/settings`,
    settingsProcore: (projectRef: string) =>
      `/${projectRef}/settings/integrations/procore`,
    availability: (projectRef: string) => `/${projectRef}/availability`,
    bookingForm: (projectRef: string, bookingRef?: string) =>
      `/${projectRef}/booking-form/${bookingRef || "new"}`,
    bookingDetails: (projectRef: string, bookingId: string) =>
      `/${projectRef}/booking/${bookingId}`,
    bookingsList: (projectRef: string) => `/${projectRef}/booking`,
    vehicleTracking: (projectRef: string) => `/${projectRef}/vehicle-tracking`,
    calendar: (projectRef: string) => `/${projectRef}/calendar`,
    equipment: (projectRef: string) => `/${projectRef}/equipment`,
    listEquipments: (projectRef: string) => `/${projectRef}/list-equipment`,
    registerEquipment: (projectRef: string) => `/${projectRef}/register-equipment`,
    monthlyUsage: (projectRef: string) => `/${projectRef}/monthly-usage`,
    vehicleMaster: (projectRef: string) => `/${projectRef}/vehicle-master`,
    vehicleEmission: (projectRef: string) => `/${projectRef}/vehicle-emission`,
    country: (projectRef: string) => `/${projectRef}/country`,
    materialEmissionReport: (projectRef: string) => `/${projectRef}/material-emission-report`,
    offRoadEmissionsReport: (projectRef: string) => `/${projectRef}/off-road-emissions-report`,
    summaryEmissionsReport: (projectRef: string) => `/${projectRef}/summary-emissions-report`,
    environmentReport: (projectRef: string) => `/${projectRef}/environment-report`,
    commonSettings: (projectRef: string) => `/${projectRef}/settings/common-settings`
  },
};

export const bookingStatuses = {
  FOR_APPROVAL: 1,
  APPROVED: 2,
  CHECKED_IN: 3,
  CHECKED_OUT: 4,
  DECLINED: 5,
  CANCELLED: 6,
  REFUSED: 7,
};

// Translation keys for the toast shown after a booking status change succeeds.
// Kept next to bookingStatuses so the booking detail modal and the booking list
// bulk actions can't drift apart when a status is added.
export const bookingStatusSuccessMessages: Record<number, string> = {
  [bookingStatuses.APPROVED]: "Translation.booking_approved_success",
  [bookingStatuses.CHECKED_IN]: "Translation.booking_checked_in_success",
  [bookingStatuses.CHECKED_OUT]: "Translation.booking_checked_out_success",
  [bookingStatuses.DECLINED]: "Translation.booking_declined_success",
  [bookingStatuses.CANCELLED]: "Translation.booking_cancelled_success",
  [bookingStatuses.REFUSED]: "Translation.booking_refused_success",
};

export const getBookingStatusSuccessMessage = (status: number) =>
  bookingStatusSuccessMessages[status] ??
  "Translation.booking_status_updated_success";
